// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__17bWO","dadosUsuario":"OptionSelect_dadosUsuario__BZAh1","focado":"OptionSelect_focado__1a5L1"};